import { _ } from "~/route/globals";
import { ROUTE_CONST } from "~/route/const";
import { icon, node } from "~/util/dom";

export function createAlternatives() {
	const routeState = Mapy.CML.state.route;

	if (!routeState.request && routeState.items.length === 2 && [ROUTE_CONST.TYPE_PUBT, ROUTE_CONST.TYPE_SKI, ROUTE_CONST.TYPE_BOAT].indexOf(routeState.params.type) === -1 && !routeState.readOnly) {
		const button = node("button", { type: "button", className: "alter" });

		button.appendChild(icon("forward"));
		button.addEventListener("click", () => {
			const actualRouteState = Mapy.CML.state.route;
			let alter = true;

			if (routeState.responseData.length > 1 && actualRouteState.alternatives && !actualRouteState.selectedAlternative) {
				alter = false;
			}

			Mapy.CML.state = {
				route: {
					alternatives: alter,
					selectedAlternative: false,
				},
			};
			requestAnimationFrame(() => {
				button.classList[alter ? "add" : "remove"]("off");
			});
		});

		if (routeState.responseData.length > 1 && routeState.alternatives && !routeState.selectedAlternative) {
			button.classList.add("off");
		} else if ((routeState.responseData.length !== 1 || routeState.items.length !== 2 || routeState.alternatives) && !routeState.selectedAlternative) {
			button.classList.add("none");
			Mapy.Util.clear(button);
			button.innerHTML = "&nbsp;";
			const span = node("span", { innerHTML: _("route.alternatives.none") });

			button.appendChild(span);

			window.setTimeout(() => {
				button.classList.add("hide");

				window.setTimeout(() => {
					button.remove();
				}, 1000);
			}, 9000);
		}

		return button;
	}

	return node("span");
}
